export default "__VITE_ASSET__3CMEuUty__"